import apiConfig from "../config/api";
import { get, post, put, requestDelete } from "../helpers/request";

const achsOffice = `${apiConfig.apiUri}api/sel/achsoffice`;

const blockingUrl = `${apiConfig.apiUri}api/sel/block`;

const openingUrl = `${apiConfig.apiUri}api/sel/opening`;

const quota = `${apiConfig.apiUri}api/sel/quotas/`;

export const GetOfficeAchs = () => get(`${achsOffice}/all`);
export const GetOpeningData = (centro, start, end) => 
  get(`${blockingUrl}/Details`, {
  //get(`http://localhost:50647/api/sel/block/Details`, {
    params: {
      officeId: centro,
      startDate: start,
      endDate: end,
    },
  });
export const GetCenterConfiguration = (centroId) => get(`${achsOffice}/${centroId}`);
export const GetAllBlockingsMonth = (centro, start, end) =>
  get(`${blockingUrl}/all`, {
  //get(`http://localhost:50647/api/sel/block/all`, {
    params: {
      officeId: centro,
      startDate: start,
      endDate: end,
    },
  });

export const getAllBlockingsWeek = (centerId, start, end) =>
  get(`${blockingUrl}/modules`, {
    params: { centerId, start, end },
  });
export const createdBlocking = (blocking) => post(
  `${blockingUrl}`,
  {
    body: JSON.stringify(blocking),
  }
);
export const updateBlocking = (blocking) => put(
  `${blockingUrl}`,
  {
    body: JSON.stringify(blocking),
  }
);
export const getAllQuotes = () => get(`${quota}/all`);

export const loadingBlockReason = () => get(`${apiConfig.apiUri}api/sel/blockingreason/all`);

export const deleteBlockingById = (id) => requestDelete(`${blockingUrl}/${id}`);
export const getAllConfigurationList = (IdCentro) => get(`${openingUrl}/configurations/all?centerId=${IdCentro}`);
//export const getAllConfigurationList = (IdCentro) => get(`${blockingUrl}/configurations/all?centerId=${IdCentro}`);
export const getConfigurationById = (id) => get(`${blockingUrl}/configurations?configurationId=${id}`);
